import { getRegisterFunction } from '../../utils/register.js';
import { OneUxContextProviderElement } from './OneUxContextProviderElement.js';
export const register = getRegisterFunction(OneUxContextProviderElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-context-provider': OneUxContextProviderElement;
    "context-provider-5501bc56fed53d03c28ddfab4764c725": OneUxContextProviderElement;
  }
}